// =============================================================================
// Article "Table of contents" scroll-spy.
// Highlights the right-rail TOC entry (bold dark text) for the section heading
// currently in view, mirroring the article mockups, and slides the green
// .aa-article-toc__marker bar along the rail to the active row.
// A section counts as "in view" once its heading reaches the anchor resting
// line (its scroll-margin-top offset); a viewport-middle line would let the
// NEXT heading steal the active state right after a TOC click jumps to a
// short section.
// =============================================================================

function init() {
	const nav = document.querySelector("[data-aa-toc]");
	if (!nav) return;

	const items = Array.from(nav.querySelectorAll(".aa-article-toc__item"));
	if (!items.length) return;

	const marker = nav.querySelector(".aa-article-toc__marker");
	let placed = false;

	// Map each TOC entry to the heading it anchors to.
	const pairs = items
		.map((item) => {
			const link = item.querySelector("a");
			if (!link) return null;
			const id = (link.getAttribute("href") || "").slice(1);
			const target = id && document.getElementById(id);
			return target ? { item, target } : null;
		})
		.filter(Boolean);

	if (!pairs.length) return;

	let ticking = false;

	// Sit the marker over the active row; the first placement skips the
	// transition so the bar does not glide in from the top on page load.
	const placeMarker = (item, instant) => {
		if (!marker) return;
		if (instant) marker.style.transition = "none";
		marker.style.top = item.offsetTop + "px";
		marker.style.height = item.offsetHeight + "px";
		if (instant) {
			void marker.offsetHeight; // Flush, so later moves animate again.
			marker.style.transition = "";
		}
	};

	const update = () => {
		ticking = false;
		// Headings carry scroll-margin-top: 86px, so a jumped-to heading rests
		// at ~86px; activate just below that resting line.
		const line = 120;
		let current = pairs[0];
		for (const pair of pairs) {
			if (pair.target.getBoundingClientRect().top <= line) {
				current = pair;
			}
		}
		// At the very bottom of the page the last heading may never cross the
		// line; hand the active state to the final section anyway.
		if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
			current = pairs[pairs.length - 1];
		}
		for (const { item } of pairs) {
			item.classList.toggle("is-current", item === current.item);
		}
		placeMarker(current.item, !placed);
		placed = true;
	};

	const onScroll = () => {
		if (!ticking) {
			ticking = true;
			window.requestAnimationFrame(update);
		}
	};

	window.addEventListener("scroll", onScroll, { passive: true });
	window.addEventListener("resize", onScroll);
	update();
}

if ("loading" === document.readyState) {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
